//  user identity tokan
export const token_key = "token";
export const setToken = (token) => {
  window.localStorage.setItem(token_key, JSON.stringify(token));
};
export const getToken = () => {
  let token = localStorage.getItem("token");
  if (!!token) return JSON.parse(token);
  return false;
};

export const setlocalStorage = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const getlocalStorage = (key) => {
  let value = localStorage.getItem(key);
  if (!!value) return JSON.parse(value);
  return false;
};

export const handleLogout = async () => {
  await localStorage.clear();
  setTimeout(() => {
    window.location.reload();
  }, 300);
}